import { Link } from '@lib/navigation';
import { TagI } from 'types/article';

interface ArticleTagsProps {
  title: string;
  tags: TagI[];
}
export default function ArticleTags({ title, tags }: ArticleTagsProps) {
  if (!tags.length) {
    return null;
  }

  return (
    <div>
      <div className=" my-2 mr-4 inline-block text-lg font-bold lg:text-xl">{title}:</div>

      <ul className="inline-flex flex-wrap">
        {tags.map((tag) => (
          <li key={tag.id} className="mb-1 mr-1">
            <Link
              href={`/tag/${tag.slug}`}
              className="block rounded-full bg-premium-900 px-2 py-1 text-sm text-white transition-colors hover:bg-premium-700 hover:text-white"
            >
              #{tag.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
